
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row, Spinner, Table } from "react-bootstrap";
import { MdOutlineCancel } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useRef } from "react";
import { useJsApiLoader, Autocomplete } from "@react-google-maps/api";

const libraries = ["places"];


const stripePromise = loadStripe("pk_live_51NmGNSCtWvaHSTZtjUsMqtoqOWJv742qg9EZQrQ4qQUxoib3JTECcjvZ9rV1AbZbo6CgscirwXvgp0y6ljOUA2kn00ZmEvhMdF");

const promotionalPrices = {
  "1 lb": { price: 11.99, originalPrice: 14.99 },
  "2 lbs": { price: 22.49, originalPrice: 29.98 },
  "5 lbs": { price: 44.99, originalPrice: 74.95 },
};

const getPromotionalPrice = (variation) => {
  if (!variation) return null;

  let text = "";
  let weightValue = null;

  if (typeof variation === "string") {
    text = variation;
  } else if (typeof variation === "object") {
    text = variation.variation_name || variation.variation || variation.selectedWeight || "";
    if (variation.weight != null) weightValue = Number(variation.weight);
    if (weightValue == null && variation.total_weight != null) {
      weightValue = Number(variation.total_weight);
    }
    if (weightValue == null && typeof variation === "object" && variation.variation_name) {
      const match = variation.variation_name.match(/(\d+(?:\.\d+)?)\s*(lb|lbs|pound|pounds)/i);
      if (match) weightValue = Number(match[1]);
    }
  }

  const name = text.toLowerCase().replace(/\s/g, "");

  if (name.includes("1lb") || name.includes("1pound") || weightValue === 1) return promotionalPrices["1 lb"];
  if (name.includes("2lbs") || name.includes("2pounds") || weightValue === 2) return promotionalPrices["2 lbs"];
  if (name.includes("5lbs") || name.includes("5pounds") || weightValue === 5) return promotionalPrices["5 lbs"];

  // Fallback on original price if weight text is missing from cart response
  const priceValue = Number(variation.price ?? variation.sale_price ?? 0);
  if (priceValue === promotionalPrices["1 lb"].originalPrice) return promotionalPrices["1 lb"];
  if (priceValue === promotionalPrices["2 lbs"].originalPrice) return promotionalPrices["2 lbs"];
  if (priceValue === promotionalPrices["5 lbs"].originalPrice) return promotionalPrices["5 lbs"];

  return null;
};

const PaymentForm = ({ onPaymentSuccess }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);

  const handlePayment = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (!stripe || !elements) {
      toast.error("Stripe not loaded");
      setLoading(false);
      return;
    }

    const cardElement = elements.getElement(CardElement);

    const { paymentMethod, error } = await stripe.createPaymentMethod({
      type: "card",
      card: cardElement,
    });

    if (error) {
      toast.error(error.message);
      setLoading(false);
      return;
    }

    onPaymentSuccess(paymentMethod.id);
  };

  return (
    <div className="mt-2">
      <CardElement />
      <button 
        type="button" 
        onClick={handlePayment}
        className="proceedCheckout3 mt-2"
        disabled={loading}
      >
        {loading ? "Processing..." : "Pay Now"}
      </button>
    </div>
  );
};


export const Main = () => {
  const addressRef = useRef(null);

 const calculateCartTotal = () => {
  let total = 0;

  cartProducts.forEach(product => {
    product.product_variations.forEach(variation => {
      const promoPrice = getPromotionalPrice(variation);

      const finalPrice = promoPrice
        ? Number(promoPrice.price)
        : Number(variation.price);

      const qty = Number(variation.quantity || 0);

      total += finalPrice * qty;
    });
  });

  return total;
};


  const [cartProducts, setCartProducts] = useState([]);
  console.log('cartProducts', cartProducts);
  const [pmId, setPmId] = useState(""); // State for payment method ID

  const [totallAmount, setTotallAmount] = useState([]);
  console.log('all data', totallAmount);
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [fetchingShippingCost, setFetchingShippingCost] = useState(true);
  const [shippingCost, setShippingCost] = useState(null); // Initially null for loader
  const [serviceCode, setServiceCode] = useState("");
  const userId = sessionStorage.getItem("userId") || sessionStorage.getItem("randomUserId");
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    email: "",
    phone: "",
    country: "",
    state: "",
    city: "",
    address: "",
    zip: "",
  });
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
    libraries,
  });

  const onPlaceChanged = () => {
    if (addressRef.current !== null) {
      const place = addressRef.current.getPlace();
      
      if (!place.address_components) return;

      let city = "";
      let state = "";
      let country = "";
      let zip = "";

      place.address_components.forEach((component) => {
        const types = component.types;
        if (types.includes("locality")) {
          city = component.long_name;
        }
        if (types.includes("administrative_area_level_1")) {
          state = component.long_name;
        }
        if (types.includes("country")) {
          country = component.short_name;
        }
        if (types.includes("postal_code")) {
          zip = component.long_name;
        }
      });

      setFormData((prev) => ({
        ...prev,
        address: place.formatted_address || "",
        city,
        state,
        country,
        zip,
      }));

      if (country && zip) {
        fetchShippingCost(country, zip);
      }
    }
  };

  const onLoad = (autocomplete) => {
    addressRef.current = autocomplete;
  };




 const handlePaymentSuccess = async (pm_id) => {
  await handleCheckout(pm_id);
};
  

 

  const getComponentValue = (components, type, useShortName = false) => {
    const component = components.find((c) => c.types.includes(type));
    return component ? (useShortName ? component.short_name : component.long_name) : "";
  };




  const fetchShippingCost = async (countryCode, postalCode) => {
    setFetchingShippingCost(true); // Show loader while fetching
    try {
      const response = await axios.get(
        `https://ecom.testingwebsitelink.com/api/testingShipping?to_country=${countryCode}&to_postal_code=${postalCode}&weight=${totalWeight}`
      );
      const shippingAmount = response.data.data[0]?.shipping_amount.amount;
      const serviceCode = response.data.data[0].service_code;
      setShippingCost(shippingAmount || 0); // Set shipping cost
      setServiceCode(serviceCode); 
      setFetchingShippingCost(false); // Hide loader after data is set
    } catch (error) {
      console.error("Error fetching shipping cost:", error);
      setShippingCost(0);
      setFetchingShippingCost(false);
    }
  };
  const handleCheckout = async (pm_id) => {
  setLoading(true);

  for (const key in formData) {
    if (!formData[key].trim()) {
      toast.error("Please fill all fields");
      setLoading(false);
      return;
    }
  }

  const finalAmount = (
    calculateCartTotal() + Number(shippingCost || 0)
  ).toFixed(2);

  console.log("Final Amount:", finalAmount);

  try {
    await axios.post(
      "https://ecom.testingwebsitelink.com/api/checkout",
      {
        ...formData,
        user_id: userId,
        amount: finalAmount,
        shipping_cost: shippingCost,
        service_code: serviceCode,
        paymentMethodId: pm_id,
      }
    );

    toast.success("Payment successful");
    setShowModal(true);
  } catch (error) {
    console.error(error);
    toast.error("Payment failed");
  }

  setLoading(false);
};
  
  const navigation = useNavigate();

  const handleCloseModal = () => {
    navigation('/')
    setShowModal(false);
  };

  const incNum = (index, variation) => {
    setCartProducts((prevProducts) => {
      if (!Array.isArray(prevProducts)) return prevProducts;
      const updatedProducts = [...prevProducts];
      const productIndex = updatedProducts.findIndex(
        (p) => p.product_id === variation.product_id
      );
      const variationIndex = updatedProducts[
        productIndex
      ].product_variations.findIndex(
        (v) => v.variation_id === variation.variation_id
      );
      const currentQuantity =
        parseInt(
          updatedProducts[productIndex].product_variations[variationIndex]
            .quantity,
          10
        ) || 0;
      updatedProducts[productIndex].product_variations[
        variationIndex
      ].quantity = currentQuantity + 1;
      handleCartUpdate(
        updatedProducts[productIndex].product_variations[variationIndex]
      );
  
      // Fetch updated shipping cost based on current address details
      fetchShippingCost(formData.country, formData.zip); // Using formData for location
  
      return updatedProducts;
    });
  };
  
  const decNum = (index, variation) => {
    setCartProducts((prevProducts) => {
      if (!Array.isArray(prevProducts)) return prevProducts;
      const updatedProducts = [...prevProducts];
      const productIndex = updatedProducts.findIndex(
        (p) => p.product_id === variation.product_id
      );
      const variationIndex = updatedProducts[
        productIndex
      ].product_variations.findIndex(
        (v) => v.variation_id === variation.variation_id
      );
      const currentQuantity =
        parseInt(
          updatedProducts[productIndex].product_variations[variationIndex]
            .quantity,
          10
        ) || 0;
      if (currentQuantity > 1) {
        updatedProducts[productIndex].product_variations[
          variationIndex
        ].quantity = currentQuantity - 1;
        handleCartUpdate(
          updatedProducts[productIndex].product_variations[variationIndex]
        );
      }
  
      // Fetch updated shipping cost based on current address details
      fetchShippingCost(formData.country, formData.zip); // Using formData for location
  
      return updatedProducts;
    });
  };
  

  const handleChange = (e, variation) => {
    const newQuantity = parseInt(e.target.value, 10);
    if (isNaN(newQuantity) || newQuantity < 0) return;
    setCartProducts((prevProducts) => {
      if (!Array.isArray(prevProducts)) return prevProducts;
      const updatedProducts = [...prevProducts];
      const productIndex = updatedProducts.findIndex(
        (p) => p.product_id === variation.product_id
      );
      const variationIndex = updatedProducts[
        productIndex
      ].product_variations.findIndex(
        (v) => v.variation_id === variation.variation_id
      );
      updatedProducts[productIndex].product_variations[
        variationIndex
      ].quantity = newQuantity;
      handleCartUpdate(
        updatedProducts[productIndex].product_variations[variationIndex]
      );
      return updatedProducts;
    });
  };

  useEffect(() => {
    const userId =
      sessionStorage.getItem("userId") ||
      sessionStorage.getItem("randomUserId");
    const token = "ihQFBEA0aED0fTxNKSd4gPi9jDXgIVh4YR13CoFE";

    if (!userId || !token) {
      console.error("User ID or token not found");
      return;
    }

    const fetchCartProducts = async () => {
      try {
        const response = await axios.get(
          `https://ecom.testingwebsitelink.com/api/getcart?user_id=${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setCartProducts(response.data.products || []); // Ensure it's an array
        setTotallAmount(response.data);
        setIsLoading(false);

        console.log("Cart Products:", response.data.products);
      } catch (error) {
        setIsLoading(false);
        console.error("Error fetching cart products:", error);
      }
    };

    fetchCartProducts();
  }, []);
  

  const totalWeight = cartProducts.reduce((sum, product) => sum + (product.total_weight || 0), 0);

  const handleCartRemove = async (variation) => {
    const userId =
      sessionStorage.getItem("userId") ||
      sessionStorage.getItem("randomUserId");
    const token = "OyZCWiISTQ6LMQBt71eC7TpwRwIThjb0osp9VVFk"; // Replace with your API token

    try {
      const response = await axios.post(
        "https://ecom.testingwebsitelink.com/api/removefromcart",
        {
          user_id: userId,
          product_id: variation.product_id,
          variation_id: variation.variation_id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Product Removed successfully:", response.data);
      // toast.success("Product Removed successfully");
      window.location.reload();

      setCartProducts((prevProducts) => {
        if (!Array.isArray(prevProducts)) return prevProducts;
        return prevProducts.filter(
          (product) =>
            product.product_id !== variation.product_id ||
            product.variation_id !== variation.variation_id
        );
      });
    } catch (error) {
      console.error("Error removing Product:", error);
      toast.error("Error removing Product");
    }
  };

  const handleCartUpdate = async (variation) => {
    const userId =
      sessionStorage.getItem("userId") ||
      sessionStorage.getItem("randomUserId");
    const token = "OyZCWiISTQ6LMQBt71eC7TpwRwIThjb0osp9VVFk"; // Replace with your API token

    try {
      const response = await axios.post(
        "https://ecom.testingwebsitelink.com/api/updatecart",
        {
          user_id: userId,
          product_id: variation.product_id,
          variation_id: variation.variation_id,
          quantity: variation.quantity,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Cart Updated successfully:", response.data);
      toast.success("Cart Updated successfully");
    } catch (error) {
      console.error("Error updating Cart:", error);
      toast.error("Error updating Cart");
    }
  };
  const clearCart = async () => {
    const userId =
      sessionStorage.getItem("userId") ||
      sessionStorage.getItem("randomUserId");
    const token = "OyZCWiISTQ6LMQBt71eC7TpwRwIThjb0osp9VVFk"; // Replace with your API token

    try {
      const response = await axios.post(
        "https://ecom.testingwebsitelink.com/api/clearcart",
        {
          user_id: userId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Variation Updated successfully:", response.data);
      // toast.success("Variation Updated successfully");
      window.location.reload();
    } catch (error) {
      console.error("Error updating variation:", error);
      toast.error("Error Removing Cart");
    }
  };

  if (isLoading) {
    return <Spinner animation="border" />;
  }

  return (
    <>
      <section className="checkoutSec">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              {cartProducts.length === 0 ? (
                <div></div>
              ) : (
                <div className="checkoutCol">
                  <h2>Contact Details</h2>
                  <button onClick={() => clearCart()} class="proceedCheckout3">
                    Clear Cart
                  </button>
                  <div className="formCheckout rendering">
                    <h2>Shipping details</h2>

                   <Form onSubmit={(e) => e.preventDefault()}>
       <h3>
          
          {fetchingShippingCost ? (
            <Spinner style={{display:'none'}} animation="border" size="sm" />
          ) : (
            <>
           
              </>
          )}
        </h3>
        <Row>
          <Col sm="6" lg="6" xl="6">
            <Form.Group className="mb-3" controlId="formBasicFirst">
              <Form.Control
                type="text"
                name="fname"
                value={formData.fname}
                onChange={(e) => {
                  console.log(e.target.value);
                  setFormData((prevData) => ({ ...prevData, [e.target.name]: e.target.value }));
                }}
                placeholder="First Name :"
                required
              />
            </Form.Group>
          </Col>
          <Col sm="6" lg="6" xl="6">
            <Form.Group className="mb-3" controlId="formBasicLast">
              <Form.Control
                type="text"
                name="lname"
                value={formData.lname}
                onChange={(e) => {console.log(e.target.value);
                  setFormData((prevData) => ({ ...prevData, [e.target.name]: e.target.value }));
                }}
                placeholder="Last Name :"
                required
              />
            </Form.Group>
          </Col>
          <Col sm="6" lg="6" xl="6">
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={(e) => {console.log(e.target.value);
                  setFormData((prevData) => ({ ...prevData, [e.target.name]: e.target.value }));
                }}
                placeholder="Email :"
                required
              />
            </Form.Group>
          </Col>
          <Col sm="6" lg="6" xl="6">
            <Form.Group className="mb-3" controlId="formBasicPhone">
              <Form.Control
                type="number"
                name="phone"
                value={formData.phone}
                onChange={(e) => {console.log(e.target.value);
                  setFormData((prevData) => ({ ...prevData, [e.target.name]: e.target.value }));
                }}
                placeholder="Phone :"
                required
              />
            </Form.Group>
          </Col>
          <Col sm="6" lg="6" xl="6">
            <Form.Group className="mb-3" controlId="formBasicAddress">
          {isLoaded ? (
            <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
              <Form.Control
                type="text"
                name="address"
                value={formData.address}
                onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                placeholder="Start typing address..."
                autoComplete="off"
              />
            </Autocomplete>
          ) : (
            <Form.Control
              type="text"
              name="address"
              value={formData.address}
              onChange={(e) => setFormData({ ...formData, address: e.target.value })}
              placeholder="Loading Maps..."
              disabled
            />
          )}

            </Form.Group>
          </Col>
          <Col sm="6" lg="6" xl="6">
            <Form.Group className="mb-3" controlId="formBasicCountry">
              <Form.Control
                type="text"
                name="country"
                value={formData.country}
                onChange={(e) => {console.log(e.target.value);
                  setFormData((prevData) => ({ ...prevData, [e.target.name]: e.target.value }));
                }}
                placeholder="Country"
                required
              />
            </Form.Group>
          </Col>
          
           
          
          <Col sm="4" lg="4" xl="4">
            <Form.Group className="mb-4" controlId="formBasicState">
              <Form.Control
                type="text"
                name="state"
                value={formData.state}
                onChange={(e) => {console.log(e.target.value);
                  setFormData((prevData) => ({ ...prevData, [e.target.name]: e.target.value }));
                }}
                placeholder="State"
                required
              />
            </Form.Group>
          </Col>
          <Col sm="4" lg="4" xl="4">
            <Form.Group className="mb-4" controlId="formBasicCity">
              <Form.Control
                type="text"
                name="city"
                value={formData.city}
                onChange={(e) => {console.log(e.target.value);
                  setFormData((prevData) => ({ ...prevData, [e.target.name]: e.target.value }));
                }}

                placeholder="Town/City :"
                required
              />
            </Form.Group>
          </Col>
          <Col sm="4" lg="4" xl="4">
            <Form.Group className="mb-3" controlId="formBasicZip">
              <Form.Control
                type="text"
                name="zip"
                value={formData.zip}
                onChange={(e) => {console.log(e.target.value);
                  setFormData((prevData) => ({ ...prevData, [e.target.name]: e.target.value }));
                }}
                placeholder="Zip Code :"
                required
              />
            </Form.Group>
          </Col>
        </Row>
        <Elements stripe={stripePromise}>
  <PaymentForm onPaymentSuccess={handlePaymentSuccess} />
</Elements>
      </Form>
      {/* Bootstrap Modal for order confirmation */}
      {/* Bootstrap Modal for order confirmation */}
<Modal show={showModal} onHide={handleCloseModal} backdrop="static">
  <Modal.Header>
    <Modal.Title>Order Confirmation</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    Order placed successfully. Please check your invoice for payment.
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={handleCloseModal}>
      Continue Shopping
    </Button>
  </Modal.Footer>
</Modal>

      

                    {/* <Elements stripe={stripePromise}>
                    <PaymentForm totallAmount={totallAmount} totalWeight={totalWeight} />
                  </Elements> */}
                  </div>
                </div>
              )}
              <div className="checkoutCol1">
                <div className="formCheckout1">
                  <h2>Your Cart</h2>
                  <div className="cartTable">
                    {cartProducts.length === 0 ? (
                      <div className="text-white pt-4">
                        <div
                          class="alert alert-warning alert-dismissible fade show text-capitalize"
                          role="alert"
                        >
                          <strong>No cart available</strong>
                        </div>
                      </div>
                    ) : (
                      <div className="cartHeader">
                        <div className="headerItem">Coffee</div>
                        <div className="headerItem">Quantity</div>
                        <div className="headerItem">Price</div>
                      </div>
                    )}
                    {isLoading ? (
                      <div className="loader-container text-center">
                        <Spinner animation="border" role="status"></Spinner>
                      </div>
                    ) : (
                      <>
                        {cartProducts.length === 0 ? (
                          <div></div>
                        ) : (
                          cartProducts.map((product) => (
                            <div className="cartItem" key={product.id}>
                              <div
                                style={{
                                  display: "flex",
                                  width: "100%",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <div className="productInfo">
                                  {product.product_images &&
                                    product.product_images.length > 0 && (
                                      <img
                                        className="productImage"
                                        src={
                                          product.product_images[0]
                                            .feature_image
                                        }
                                        alt="Product"
                                      />
                                    )}
                                  <div className="productDetails">
                                    <h5>{product.product_name}</h5>
                                  </div>
                                </div>
                              </div>
                              <div className="row justify-content-center">
                                <div className="col-md-12">
                                  <div className="table-responsive">
                                    <Table id="myTable" className="table">
                                      <tbody>
                                        {product.product_variations &&
                                          product.product_variations.length >
                                            0 &&
                                          product.product_variations.map(
                                            (variation, index) => (
                                              <tr key={index}>
                                                <td>
                                                  <div className="product-img">
                                                    <div className="img-prdct">
                                                      <img
                                                        src={variation.image}
                                                        alt={
                                                          variation.variation_name
                                                        }
                                                      />
                                                    </div>
                                                  </div>
                                                </td>
                                                <td>
                                                  <p>
                                                    {variation.variation || variation.variation_name}
                                                  </p>
                                                </td>
                                                <td>
                                                  <div className="button-container">
                                                    <button
                                                      className="cart-qty-minus"
                                                      type="button"
                                                      value="-"
                                                      onClick={() =>
                                                        decNum(index, variation)
                                                      }
                                                    >
                                                      -
                                                    </button>
                                                    <input
                                                      type="text"
                                                      name="qty"
                                                      min="1"
                                                      readOnly
                                                      className="qty form-control"
                                                      value={
                                                        variation.quantity || 0
                                                      }
                                                      onChange={(e) =>
                                                        handleChange(
                                                          e,
                                                          variation
                                                        )
                                                      }
                                                    />
                                                    <button
                                                      className="cart-qty-plus"
                                                      type="button"
                                                      value="+"
                                                      onClick={() =>
                                                        incNum(index, variation)
                                                      }
                                                    >
                                                      +
                                                    </button>
                                                  </div>
                                                </td>
                                               <td align="right" style={{ display: "flex" }}>
  ${" "}
  {(() => {
    const promoPrice = getPromotionalPrice(variation);
    const finalPrice = promoPrice ? promoPrice.price : variation.price;
    const total = (finalPrice * variation.quantity).toFixed(2);

    return (
      <span id="amount" className="amount">
        {total}
      </span>
    );
  })()}
</td>
                                                <td>
                                                  <MdOutlineCancel
                                                    onClick={() =>
                                                      handleCartRemove(
                                                        variation
                                                      )
                                                    }
                                                    className="cancel"
                                                  />
                                                </td>
                                              </tr>
                                            )
                                          )}
                                      </tbody>
                                    </Table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {cartProducts.length === 0 ? (
              <div></div>
            ) : (
              <div className="col-lg-5">
                <div className="checkoutCol2 checkoutCol1">
                  <div className="formCheckout2">
                    <h2>ORDER DETAILS</h2>
                    <div className="cartTable">
                      {isLoading ? (
                        <div className="loader-container text-center">
                          <Spinner animation="border" role="status" />
                        </div>
                      ) : (
                        <>
                          {cartProducts.length === 0 ? (
                            <div className="text-white pt-4">
                              No cart available
                            </div>
                          ) : (
                            cartProducts.map((product) => (
                              <div className="cartItem" key={product.id}>
                                <div
                                  style={{
                                    display: "flex",
                                    width: "100%",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <div className="productInfo">
                                    {product.product_images &&
                                      product.product_images.length > 0 && (
                                        <img
                                          className="productImage"
                                          src={
                                            product.product_images[0]
                                              .feature_image
                                          }
                                          alt="Product"
                                        />
                                      )}
                                    <div className="productDetails">
                                      <h5>{product.product_name}</h5>
                                    </div>
                                  </div>
                                </div>
                                <div className="row justify-content-center">
                                  <div className="col-md-12">
                                    <div className="table-responsive">
                                      <Table id="myTable" className="table">
                                        <tbody>
                                          {product.product_variations &&
                                            product.product_variations.length >
                                              0 &&
                                            product.product_variations.map(
                                              (variation, index) => (
                                                <tr key={index}>
                                                  <td>
                                                    <div className="product-img">
                                                      <div className="img-prdct">
                                                        <img
                                                          src={variation.image}
                                                          alt={
                                                            variation.variation_name
                                                          }
                                                        />
                                                      </div>
                                                    </div>
                                                  </td>
                                                  <td>
                                                    <p>
                                                      {variation.variation || variation.variation_name}
                                                    </p>
                                                  </td>
                                                  <td>
                                                    <div className="button-container">
                                                      <button
                                                        className="cart-qty-minus"
                                                        type="button"
                                                        value="-"
                                                        onClick={() =>
                                                          decNum(
                                                            index,
                                                            variation
                                                          )
                                                        }
                                                      >
                                                        -
                                                      </button>

                                                      <input
                                                        type="number"
                                                        name="qty"
                                                        min="1"
                                                        readOnly
                                                        className="qty form-control"
                                                        value={
                                                          variation.quantity ||
                                                          0
                                                        }
                                                        onChange={(e) =>
                                                          handleChange(
                                                            e,
                                                            variation
                                                          )
                                                        }
                                                      />
                                                      <button
                                                        className="cart-qty-plus"
                                                        type="button"
                                                        onClick={() =>
                                                          incNum(
                                                            index,
                                                            variation
                                                          )
                                                        }
                                                      >
                                                        +
                                                      </button>
                                                    </div>
                                                  </td>
                                                 <td align="right" style={{ display: "flex" }}>
  ${" "}
  {(() => {
   const promoPrice = getPromotionalPrice(variation);
const finalPrice = promoPrice ? promoPrice.price : variation.price;
const total = (finalPrice * variation.quantity).toFixed(2);

    return (
      <span id="amount" className="amount">
        {total}
      </span>
    );
  })()}
</td>
                                                  <td>
                                                    <MdOutlineCancel
                                                      onClick={() =>
                                                        handleCartRemove(
                                                          variation
                                                        )
                                                      }
                                                      className="cancel"
                                                    />
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                        </tbody>
                                      </Table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))
                          )}
                        </>
                      )}
                    </div>
                    <div className="cartDetails">
                      <h2>Have a coupon? Click here to enter your code</h2>
                      <hr />

                      <div className="detailsOfProduct">
                        <h2>Shipping</h2>
                        <h2> {fetchingShippingCost ? (
                          <span>---</span>
          ) : (
            <>
            ${shippingCost }
              </>
          )}</h2>
                      </div>
                      <hr />
                      <div className="detailsOfProduct">
                        <h2>Total</h2>
                        <h2 className="total-amount">
                          $ {(calculateCartTotal() + Number(shippingCost || 0)).toFixed(2)}
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="brandLogo">
                  <img
                    src={require("../assets/images/Coffeebrand1.png")}
                    alt=""
                  />
                  <img
                    src={require("../assets/images/Coffeebrand2.png")}
                    alt=""
                  />
                  <img
                    src={require("../assets/images/Coffeebrand3.png")}
                    alt=""
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};
